import SelectOption from "../@types/SelectOption"

const CanadaStates: SelectOption[] = [
    {
        label: 'Alberta',
        value: ['Alberta', 'AB']
    },
    {
        label: 'British Columbia',
        value: ['British Columbia', 'BC']
    },
    {
        label: 'Manitoba',
        value: ['Manitoba', 'MB']
    },
    {
        label: 'New Brunswick',
        value: ['New Brunswick', 'NB']
    },
    {
        label: 'Newfoundland',
        value: ['Newfoundland', 'NF']
    },
    {
        label: 'Northwest Territories',
        value: ['Northwest Territories', 'NT']
    },
    {
        label: 'Nova Scotia',
        value: ['Nova Scotia', 'NS']
    },
    {
        label: 'Nunavut',
        value: ['Nunavut', 'NU']
    },
    {
        label: 'Ontario',
        value: ['Ontario', 'ON']
    },
    {
        label: 'Prince Edward Island',
        value: ['Prince Edward Island', 'PE']
    },
    {
        label: 'Quebec',
        value: ['Quebec', 'PQ']
    },
    {
        label: 'Saskatchewan',
        value: ['Saskatchewan', 'SK']
    },
    {
        label: 'Yukon',
        value: ['Yukon', 'YT']
    },
    
]

export default CanadaStates;